function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import deepmerge from 'deepmerge';

const mergeStyles = defaultStyle => Component => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        mergedStyles: this.props.styles ? deepmerge(defaultStyle, this.props.styles) : defaultStyle
      };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps !== this.props) this.setState({
        mergedStyles: this.props.styles ? deepmerge(defaultStyle, this.props.styles) : defaultStyle
      });
    }

    render() {
      const {
        styles,
        ...rest
      } = this.props;
      return (
        /*#__PURE__*/
        React.createElement(Component, _extends({
          styles: this.state.mergedStyles
        }, rest))
      );
    }

  };
};

export default mergeStyles;